import { FormControl } from "@chakra-ui/form-control";
import { Input } from "@chakra-ui/input";
import { Box, Text } from "@chakra-ui/layout";
import "./styles.css";
import {
  Button,
  IconButton,
  Spinner,
  useToast,
  InputGroup,
  InputRightElement,
} from "@chakra-ui/react";
import { getSender, getSenderFull } from "../config/ChatLogics";
import { useEffect, useState } from "react";
import axios from "axios";
import { ArrowBackIcon } from "@chakra-ui/icons";
import ProfileModal from "./miscellaneous/ProfileModal";
import ScrollableChat from "./ScrollableChat";
import Lottie from "react-lottie";
import animationData from "../animations/typing.json";
import io from "socket.io-client";
import UpdateGroupChatModal from "./miscellaneous/UpdateGroupChatModal";
import { ChatState } from "../Context/ChatProvider";
import { FaArrowLeft } from "react-icons/fa";
import useWindowDimensions from "../../CustomHooks/useWindowdimension";
import { FiSend } from "react-icons/fi";
import { BiSend } from "react-icons/bi";
import { FaPlus } from "react-icons/fa";

// import { AiOutlineSend, IoIosSend, FaPaperPlane } from 'react-icons/io';
import Button1 from "../../components/ResubleComp/Button";
const ENDPOINT = process.env.REACT_APP_BASE_URL; // "https://Fynii-Practice-Chat.herokuapp.com"; -> After deployment
var socket, selectedChatCompare;

const SingleChat = ({ fetchAgain, setFetchAgain, setIsDrawerOpen, onOpen }) => {
  const token = localStorage.getItem("TOKEN");
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [newMessage, setNewMessage] = useState("");
  const [socketConnected, setSocketConnected] = useState(false);
  const [typing, setTyping] = useState(false);
  const [istyping, setIsTyping] = useState(false);
  const { height, width } = useWindowDimensions();
  const toast = useToast();
  console.log("yrrnewmessaee", newMessage);
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const { selectedChat, setSelectedChat, user, notification, setNotification } =
    ChatState();

  const fetchMessages = async () => {
    if (!selectedChat) return;

    try {
      const config = {
        headers: {
          Authorization: token,
        },
      };

      setLoading(true);

      const { data } = await axios.get(
        `${ENDPOINT}/api/message/${selectedChat._id}`,
        config
      );
      setMessages(data);
      setLoading(false);

      socket.emit("join chat", selectedChat._id);
    } catch (error) {
      toast({
        title: "Error Occured!",
        description: "Failed to Load the Messages",
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
    }
  };

  const sendMessage = async (event) => {
    if (newMessage) {
      socket.emit("stop typing", selectedChat._id);
      try {
        const config = {
          headers: {
            "Content-type": "application/json",
            Authorization: token,
          },
        };
        setNewMessage("");
        const { data } = await axios.post(
          `${ENDPOINT}/api/message`,
          {
            content: newMessage,
            chatId: selectedChat,
          },
          config
        );
        socket.emit("new message", data);
        console.log("emitdata", data);
        setMessages([...messages, data]);
      } catch (error) {
        toast({
          title: "Error Occured!",
          description: "Failed to send the Message",
          status: "error",
          duration: 5000,
          isClosable: true,
          position: "bottom",
        });
      }
    }
  };

  useEffect(() => {
    socket = io(ENDPOINT);
    socket.emit("setup", user);
    console.log("useruseeffect", user);
    socket.on("connected", () => setSocketConnected(true));
    socket.on("typing", () => setIsTyping(true));
    socket.on("stop typing", () => setIsTyping(false));

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    fetchMessages();
    selectedChatCompare = selectedChat;
    // eslint-disable-next-line
  }, [selectedChat]);

  useEffect(() => {
    socket.on("message recieved", (newMessageRecieved) => {
      console.log("newMessageRecieved", newMessageRecieved);
      console.log("selectedChatCompare", selectedChatCompare);
      if (
        !selectedChatCompare || // if chat is not selected or doesn't match current chat
        selectedChatCompare._id !== newMessageRecieved.chat._id
      ) {
        if (!notification.includes(newMessageRecieved)) {
          setNotification([newMessageRecieved, ...notification]);
          setFetchAgain(!fetchAgain);
        }
      } else {
        setMessages([...messages, newMessageRecieved]);
      }
    });
  });

  const typingHandler = (e) => {
    setNewMessage(e.target.value);

    if (!socketConnected) return;

    if (!typing) {
      setTyping(true);
      socket.emit("typing", selectedChat._id);
    }
    let lastTypingTime = new Date().getTime();
    var timerLength = 3000;
    setTimeout(() => {
      var timeNow = new Date().getTime();
      var timeDiff = timeNow - lastTypingTime;
      if (timeDiff >= timerLength && typing) {
        socket.emit("stop typing", selectedChat._id);
        setTyping(false);
      }
    }, timerLength);
  };

  return (
    <>
      {selectedChat ? (
        <>
          <Text
            style={{
              fontSize: width > 768 ? "22px" : "15px",
              display: "flex",
              gap: "20px",
            }}
            pb={3}
            px={2}
            w="100%"
            fontFamily="Work sans"
            d="flex"
            alignItems="center"
          >
            {messages &&
              (!selectedChat.isGroupChat ? (
                <>
                  <button
                    borderBottomWidth="1px"
                    onClick={() => {
                      setIsDrawerOpen(true);
                    }}
                    className="lg:hidden md:block xl:hidden 2xl:hidden cursor-pointer"
                  >
                    <FaArrowLeft />
                  </button>
                  {getSender(user, selectedChat.users)}
                  <ProfileModal
                    user={getSenderFull(user, selectedChat.users)}
                  />
                </>
              ) : (
                <>{selectedChat.chatName.toUpperCase()}</>
              ))}
          </Text>
          <Box
            d="flex"
            flexDir="column"
            p={3}
            bg="#f6f4f4"
            w="100%"
            h="83%"
            borderRadius="lg"
            overflow="scroll"
          >
            {loading ? (
              <Spinner
                size="xl"
                w={20}
                h={20}
                alignSelf="center"
                margin="auto"
              />
            ) : (
              <div className="messages">
                <ScrollableChat messages={messages} />
              </div>
            )}
            {istyping ? (
              <div>
                <Lottie
                  options={defaultOptions}
                  width={70}
                  style={{ marginBottom: 15, marginLeft: 0 }}
                />
              </div>
            ) : (
              <></>
            )}
          </Box>
          <InputGroup size="md" mt="1">
            <Input
              pr="4.5rem"
              variant="filled"
              id="first-name"
              bg="#f6f4f4"
              placeholder="Enter a message.."
              value={newMessage}
              onChange={typingHandler}
              className="first-name"
            />
            <InputRightElement width="4.5rem">
              <Button1 onClick={sendMessage} className="ml-9 cursor-pointer">
                <BiSend size={30} />{" "}
              </Button1>
            </InputRightElement>
          </InputGroup>
        </>
      ) : (
        // to get socket.io on same page
        <Box className="flex items-center justify-center h-[100%]">
          <Text fontSize="3xl" pb={3} fontFamily="Work sans">
            <h1 style={{ display: width > 768 ? "block" : "none" }}>
              Click on a user to start chatting{" "}
              <FaPlus size={20} className="lg:hidden md:hidden block" />
            </h1>
            <h1
              style={{ display: width > 768 ? "none" : "block" }}
              onClick={() => {
                setIsDrawerOpen(true);
              }}
            >
              No user found please go back{" "}
              <Button1 className="my-5 mx-5">
                {" "}
                <FaArrowLeft
                  size={20}
                  className="lg:hidden md:hidden block cursor-pointer text-blue-500"
                />{" "}
              </Button1>
            </h1>
          </Text>
        </Box>
      )}
    </>
  );
};

export default SingleChat;
